import React from "react";
import { TrialBalanceContainer } from "../../../containers";

const TrailBalance = (props) => {
  return <TrialBalanceContainer {...props} />;
};
export default TrailBalance;
